import React, { useMemo } from 'react';
import { Property } from './Property';
import { sortMembersBySortOrderFirst } from '../../../../../utils/applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder/index';

interface PropertiesListProps {
  node: any;
  prefix: string;
}

export function PropertiesList({ node, prefix }: PropertiesListProps) {
  const sortedNodeProperties = useMemo(() => {
    return sortMembersBySortOrderFirst(node?.data?.properties || []) || [];
  }, [node]);

  return (
    <>
      {sortedNodeProperties.map((property) => (
        <Property
          key={`property_${prefix}__${property.name}`}
          property={property}
          node={node}
          prefix={prefix}
        />
      ))}
    </>
  );
}
